import { render } from "./CardShareRequest.vue?vue&type=template&id=08ff7a16&scoped=true"
import script from "./CardShareRequest.vue?vue&type=script&lang=js"
export * from "./CardShareRequest.vue?vue&type=script&lang=js"

import "./CardShareRequest.vue?vue&type=style&index=0&id=08ff7a16&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08ff7a16"]])

export default __exports__